import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import "firebase/functions";

import modules from "./modules";
import { RootState } from "./types";
import { api as userApi } from "./modules/user";
import { actionsNs, gettersNs } from "./utils";

Vue.use(Vuex);

export const api = {
  namespace: null,
  getters: {
    isUserAuthenticated: "isUserAuthenticated",
  },
  mutations: {},
  actions: {
    init: "init",
  },
  state: {
    version: "version",
    loading: "loading",
  },
};

console.log("modules", modules);

const store: StoreOptions<RootState> = {
  state: new RootState(),

  actions: {
    async [api.actions.init](context) {
      await context.dispatch(
        actionsNs(userApi, userApi.actions.init),
        undefined,
        {
          root: true,
        }
      );
    },
  },
  mutations: {},
  getters: {
    [api.getters.isUserAuthenticated](
      _state,
      _getters,
      _rootState,
      rootGetters
    ) {
      return (
        rootGetters[gettersNs(userApi, userApi.getters.getUserId)] !== null
      );
    },
  },
  modules,
  strict: process.env.NODE_ENV !== "production",
};

const vuexStore = new Vuex.Store<RootState>(store);

export default vuexStore;
